var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirecrackersAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.124 2.33808C11.8943 1.98928 11.4286 1.89503 11.084 2.12756C10.7393 2.36009 10.6462 2.83135 10.876 3.18015L11.4212 4.00786C11.4873 4.10821 11.4742 4.24183 11.39 4.32711L11.083 4.63774C10.4672 5.26096 10.3978 6.24765 10.9204 6.95277L11.5626 7.81934H9C8.44771 7.81934 8 8.27244 8 8.83138V10.0964H16V8.83138C16 8.27244 15.5523 7.81934 15 7.81934H13.218C13.1678 7.55773 13.0597 7.30944 12.9 7.09392L12.1204 6.04193C12.0457 5.9412 12.0556 5.80025 12.1436 5.71122L12.4506 5.40059C13.0405 4.80363 13.132 3.86825 12.6693 3.16578L12.124 2.33808Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6145V18.2048H16V11.6145H8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.7229H8V20.988C8 21.5469 8.44771 22 9 22H15C15.5523 22 16 21.5469 16 20.988V19.7229Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirecrackersAlt);
export default __webpack_public_path__ + "static/media/firecrackers-alt.cfc66dc4c979bb0717bf71e4650f0e50.svg";
export { ForwardRef as ReactComponent };